<template>
  <button
    :disabled="props.loading || !props.buttonActive"
    :class="[
      'flex w-full justify-center rounded-md border border-transparent px-6 py-2 text-sm font-normal text-white-500 shadow-sm duration-300  focus:outline-hidden focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
      props.loading ? ['bg-primary-200 hover:bg-primary-200'] : '',
      !props.buttonActive
        ? ['bg-neutral-500 hover:bg-neutral-500']
        : 'bg-primary-500 hover:bg-primary-600',
    ]"
    @click="doClick"
  >
    <TIcon
      v-if="props.loading"
      name="loader"
      class="mr-2 h-5 w-5 animate-spin"
    />
    <span v-if="!props.loading">
      <slot />
    </span>
  </button>
</template>

<script setup lang="ts">
const props = defineProps({
  loading: { type: Boolean, required: false, default: false },
  action: { type: Function, required: false, default: null },
  buttonActive: { type: Boolean, required: false, default: true },
  dataTestName: { type: String, required: false, default: '' },
});
const emit = defineEmits(['action']);

function doClick() {
  emit('action');
  if (props.action) {
    props.action();
  }
}
</script>
